import { CameraControls } from '@react-three/drei';
import { Canvas } from '@react-three/fiber'; // , useFrame, useLoader
import { Physics } from '@react-three/rapier';
import { useContext, useEffect } from 'react';

/* Animation */
import Explosions from '@/components/game/3d/animation/Explosions';
import FluidBackgroundCoal2 from '@/components/game/3d/animation/FluidBackgroundCoal2';
import MovingFog from '@/components/game/3d/animation/MovingFog';
/* 3d Component */
import TableBuilder from '@/components/game/3d/builder/TableBuilder';
import CameraRig from '@/components/game/3d/camera/CameraRig';
/* UI */
import AnimatedTickerToast from '@/components/game/ui/AnimatedTickerToast';
/* UI Corners */
import MetaCluster from '@/components/game/ui/corner/MetaCluster';
import PaymentCluster from '@/components/game/ui/corner/PaymentCluster';
/* Style */
import '@/style/Canvas.css';
import '@/style/UI.css';
import TickerActionCluster from '@/components/game/ui/corner/TickerActionCluster';
import TurnIndicator from '@/components/game/ui/corner/TurnIndicator';
import TurnIndicatorAbsolute from '@/components/game/ui/corner/TurnIndicatorAbsolute';
import EndgameDisplay from '@/components/game/ui/EndgameDisplay';
import ModalContainer from '@/components/game/ui/modal/ModalContainer';
import TickerWithHover from '@/components/game/ui/TickerWithHover';
import LyocTitleAbsolute from '@/components/static/LyocTitleAbsolute';
import { GameContext, ViewContext } from '@/state/contexts';
import { logg } from '@/util/logg';

import { useTutorial } from '@/hooks/useTutorial';
import { getPlayerStateWithId } from '@/util/player';
import { tutStep_1, tutStep_13, tutStep_14, tutStep_15, tutStep_16, tutStep_20, tutStep_21, tutStep_24, tutStep_25, tutStep_27, tutStep_3, tutStep_30, tutStep_4, tutStep_50 } from '@/lyoc-common/src/const/tutorial';

/**
 * TODO IF IS TUTORIAL, replace endTurn with "endTutorialTurn" to advance to the next tutorial step, write the next message and update the gameState
 * Hardcode AI at start
 * extend AnimatedTickerToast to like 30 minutes, make hitting next when in tutorial mode to move to the next toast.
 */

const Board3DTutorial = () => {
	const enableAxisHelper = false;
	const {
		currPlayer,
		players,
		playerStateArray,
		myState,

		singlePlayer,

		gameStatus,

		setSelectedAction,
		setSelectedActionCost,

		setSourceId,
		setTargetId,
		setChoiceInt,

		setSeasonalNewsCards,

		setIsTutorial,
		stepTutorial
	}: any = useContext(GameContext);

	const { tutorialCheck } = useTutorial();

	const {
		setCamState,
		camState,

		showTicker,
		setShowTicker,

		backgroundEffects,

		setPPE,
		pPE,
		setPPC,
		pPC,

		verboseUI,
		// verboseAction,
		// verboseSettings,

		// toggleVerboseAction,
		// toggleVerboseSettings,

		showTheFunny,

		viewNewsCards,
		paymentMode,
		setTickerTimeoutSeconds,
		setVerboseSettings,
	}: any = useContext(ViewContext);

	useEffect(() => {
		if (
			playerStateArray == null ||
			currPlayer == null ||
			currPlayer.playerId == null ||
			myState == null
		) {
			return;
		}
		if (
			playerStateArray == null ||
			currPlayer == null ||
			currPlayer?.playerId == null ||
			myState.factoryEnergyArr == null ||
			myState == null ||
			myState.batteryEnergyArr == null
		) {
			return;
		}
		setPPE(
			myState.factoryEnergyArr.length + myState.batteryEnergyArr.length
		);
		setPPC(myState.carbonReserve);
		logg(`2 pPE: ${pPE} & pPC ${pPC}`);
		logg(myState.batteries >= 1 ? 2 : 1);
	}, [playerStateArray, currPlayer]);

	useEffect(() => {
		if (gameStatus > 0) {
			setCamState('spin');
		} else {
			setCamState('player');
		}
	}, [gameStatus]);

	useEffect(() => {
		setIsTutorial(true);
		setTickerTimeoutSeconds(1200 * 60);
		setVerboseSettings(true);
		setShowTicker(false);
	}, []);

	// TUTORIAL STATE EDITOR !!!
	// TUTORIAL STATE EDITOR !!!
	useEffect(() => {
		// when we reach certain steps, update our player's state
		switch(stepTutorial){
			case(tutStep_14):
				setSeasonalNewsCards([7])
				myState.factoryEnergyArr = ['y','y'];
				setPPE(2);
				break;
			case(tutStep_21):
				myState.seasonalCards.push(64);
				break;
			case(tutStep_25):
				myState.seasonalCards.push(40);
				break;
			case(tutStep_27):
				myState.batteryEnergyArr.push('y');
				myState.seasonalCards = [35];
				break;
		}



	}, [stepTutorial])

	function resetPlayerActionHooks() {
		setSelectedAction('');
		setSelectedActionCost(0);
		setSourceId(-1);
		setTargetId(-1);
		setChoiceInt(-1);
	}

	if (!playerStateArray || playerStateArray.length < 1) {
		if (
			!singlePlayer ||
			players.length <= 1 ||
			playerStateArray.length < 1
		) {
			logg('I aint got nobody to play with');
			return;
		}
		logg('Starting single player game');
	}

	/**
	 * HTML PORTION
	 */

	if (
		playerStateArray == null &&
		currPlayer == null &&
		currPlayer.playerId == null
	) {
		return;
	}

	// GAMEPLAY DISPLAY
	return (
		<>
			<AnimatedTickerToast />
			<ModalContainer />
			{(gameStatus === 1 || gameStatus === 2) && <EndgameDisplay />}
			{showTheFunny && (
				<iframe
					width="560"
					height="315"
					src="https://www.youtube.com/embed/dQw4w9WgXcQ?autoplay=1"
					frameBorder="0"
					allow="autoplay;"
					allowFullScreen
				></iframe>
			)}

			<div className="canvasContainer">
				{tutorialCheck(tutStep_20) && 
					<div
						className={`tickerWrapper ${showTicker ? '' : 'hidden'}`}
						aria-hidden={!showTicker}
					>
						{verboseUI && <TurnIndicator />}
						{showTicker && <TickerWithHover />}
					</div>
				}

				<div className="threeWrapper">
					<Canvas
						frameloop="always"
						flat
						dpr={[1, 2]}
						camera={{ fov: 25, position: [0, 0, 0] }}
					>
						<CameraControls />
						<CameraRig />
						{enableAxisHelper && <axesHelper args={[20]} />}
						{gameStatus === 1 && <Explosions />}
						<color attach="background" args={['#22262a']} />

						{backgroundEffects && (
							<>
								<FluidBackgroundCoal2 />
								<MovingFog />
							</>
						)}

						<ambientLight intensity={0.2} />
						<directionalLight
							position={[5, 5, 5]}
							intensity={1.5}
						/>
						<directionalLight position={[10, 20, 45]} />
						<Physics gravity={[0, -9.81, 0]}>
							{tutorialCheck(tutStep_3) && (
								<TableBuilder
									camState={camState}
									viewNewsCards={viewNewsCards}
								/>
							)}
						</Physics>
					</Canvas>

					{tutorialCheck(tutStep_4) && (
						<>
							{verboseUI && (
								<>
									<LyocTitleAbsolute showImg={true} />
									{!showTicker && <TurnIndicatorAbsolute />}
								</>
							)}
						</>
					)}
					{<TickerActionCluster />}
					{tutorialCheck(tutStep_15) &&
						(paymentMode ? <PaymentCluster /> : tutorialCheck(tutStep_30) ? <MetaCluster /> : <></>)}
				</div>
			</div>
		</>
	);
};

export default Board3DTutorial;
